export default "__VITE_ASSET__DwG6DaJD__"